/**
 * Call this function to trigger async update of balance
 * on Aspire portals
 */
export function updateAspireBalance() {
  window.postMessage({ action: "balanceUpdated" }, "*");
}

/**
 * Store data in window dataLayer for GTM
 * @param {number} betslipGroupId - placed betslip group id
 * @param {import('bto-models/betslip/interfaces').BetslipStore} [betslipData] - placed betslipData store
 */
export function addGTMEventOnPlace(betslipGroupId, betslipData) {
  if (betslipData) {
    window.dataLayer.push({
      event: 'sport_bet_placed',
      bet_id: betslipGroupId,
      max_odd: betslipData.totals.maxOdds,
      total_stake: betslipData.totals.stake,
      number_of_items: Object.keys(betslipData.items).length,
      PID: APP_SETTINGS.player.id,
    });
  }
}